import axios from 'axios'
// import router from './../../../router'

export const getRotis = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-rotis/" + payload)
            .then((response) => {
                commit('SET_ROTIS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeRoti = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post("/api/store-roti", payload).then((response) => {
            dispatch("getRotis", !payload.isSuperAdmin ? payload.jensek_id : 99).then(() => {
                let notif = {
                    msg: nama + " Berhasil ditambahkan~",
                    type: "create"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const updateRoti = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put("/api/update-roti/" + payload.id, payload).then((response) => {
            dispatch("getRotis", !payload.isSuperAdmin ? payload.jensek_id : 99).then(() => {
                let notif = {
                    msg: nama + " Berhasil diupdate~",
                    type: "update"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });

        }).catch((e) => {
            reject(e.response.data.errors);
            commit("SET_OVERLAY", false, { root: true });
        });
    })
}

export const deleteRoti = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.delete("/api/hapus-roti/" + payload.id).then((response) => {
            dispatch("getRotis", !payload.isSuperAdmin ? payload.jensek_id : 99).then(() => {
                let notif = {
                    msg: nama + " Berhasil dihapus~",
                    type: "delete"
                }
                commit("SET_NOTIF", notif, { root: true });
                resolve("ok")
            });
        }).catch((e) => {
            if (e.response.data.code == 1451) {
                let existNotif = "*Data telah memiliki hubungan dengan data rombongan belajar!";
                commit("SET_SQL", existNotif, { root: true });
            }

            commit("SET_OVERLAY", false, { root: true });
        });
    })
}